import React, { useEffect, useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; 
import axios from "axios";
import { config } from "../../../config";

const apiUrl = config.apiUrl;

const CreateService = ({ onServiceCreated }) => {
  const [formData, setFormData] = useState({
    service_name: "",
    image: null,
    description: "",
    duration: "",
    selling_price: "",
    discount_price: "",
    membership_type: "",
  });

  const [error, setError] = useState(null);
  const [membershipsForServices, setMembershipsForServices] = useState([])

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (files) {
      setFormData((prev) => ({ ...prev, [name]: files[0] }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleQuillChange = (value) => {
    setFormData((prev) => ({
      ...prev,
      description: value || "", // খালি ভ্যালুর জন্য "" সেট করুন
    }));
  };

  useEffect(() => {
    const fetchMemberships = async () => {
      try {
        const response = await axios.get(`${apiUrl}/memberships`);
          
        setMembershipsForServices(response.data);
      } catch (err) {
        console.error("Error fetching services:", err);
      }
    };

    fetchMemberships();
  }, []);

console.log(membershipsForServices)

  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = new FormData();
    data.append("service_name", formData.service_name);
    data.append("image", formData.image);
    data.append("description", formData.description);
    data.append("duration", formData.duration);
    data.append("selling_price", formData.selling_price);
    data.append("discount_price", formData.discount_price);
    data.append("membership_type", formData.membership_type);

    try {
      await axios.post(`${apiUrl}/services`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      alert("Service Created Successfully!");
      onServiceCreated();
    } catch (err) {
      setError(err?.response?.data?.message);
    }
  };

  return (
    <div className="p-6 max-w-lg mx-auto bg-white shadow rounded">
      <h2 className="text-2xl font-bold mb-4">Create Service</h2>
      {error && <p className="text-red-500">{error}</p>}
      <form onSubmit={handleSubmit}>
        <div className="mb-4">
          <label className="block text-gray-700">Service Name</label>
          <input
            type="text"
            name="service_name"
            value={formData.service_name}
            onChange={handleChange}
            className="border w-full p-2"
            required
          />
        </div>
        <div className="mb-4">
          <label className="block text-gray-700">Service Image</label>
          <input
            type="file"
            name="image"
            onChange={handleChange}
            className="border w-full p-2"
            accept="image/*"
          />
        </div>
        <div className="mb-4">
          <label className="block text-gray-700">Description</label>
          <ReactQuill
            value={formData.description || ""} // Ensure Quill gets a valid string
            onChange={handleQuillChange}
            className="border w-full p-2"
          />
        </div>
        <div className="mb-4">
          <label className="block text-gray-700">Duration (months)</label>
          <input
            type="text"
            name="duration"
            value={formData.duration}
            onChange={handleChange}
            className="border w-full p-2"
            required
          />
        </div>
        <div className="mb-4">
          <label className="block text-gray-700">Selling Price (Tk)</label>
          <input
            type="number"
            name="selling_price"
            value={formData.selling_price}
            onChange={handleChange}
            className="border w-full p-2"
            required
          />
        </div>
        <div className="mb-4">
          <label className="block text-gray-700">Discount Price (Tk)</label>
          <input
            type="number"
            name="discount_price"
            value={formData.discount_price}
            onChange={handleChange}
            className="border w-full p-2"
            required
          />
        </div>
        <div className="mb-4">
          <label className="block text-gray-700">Membership Type</label>
          <select
            name="membership_type"
            value={formData.membership_type}
            onChange={handleChange}
            className="border w-full p-2"
          >
            <option value="">Select Membership Type</option>
            {membershipsForServices?.map((membership) => (
              <option key={membership.id} value={membership.id}>
                {membership.membership_type}
              </option>
            ))}
          </select>
        </div>
        <button
          type="submit"
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
        >
          Create Service
        </button>
      </form>
    </div>
  );
};

export default CreateService;
